/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SiretVerificationResponse } from '../models/SiretVerificationResponse';
import type { VerifySiretDto } from '../models/VerifySiretDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SiretVerificationService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Verify a SIRET number via the INSEE API
     * Validates a French SIRET number and returns company information (name, address). Returns the verification status: visible (valid and public), hidden (exists but data is restricted), or not_found (invalid or does not exist).
     * @returns SiretVerificationResponse SIRET verification result.
     * @throws ApiError
     */
    public siretVerificationControllerVerify({
        requestBody,
    }: {
        requestBody: VerifySiretDto,
    }): CancelablePromise<SiretVerificationResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/siret-verification',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error. SIRET must be exactly 14 digits.`,
            },
        });
    }
}
